import api from "@/api";

export async function getItems(tipo, offset, limit, filter = {}) {
    try {
        let query = `?offset=${offset}&limit=${limit}`;

        if (filter.name) query += `&name=${encodeURIComponent(filter.name)}`;
        if (filter.id) query += `&id=${encodeURIComponent(filter.id)}`;
        if (filter.label) query += `&label=${encodeURIComponent(filter.label)}`;
        if (filter.thirdPartiesID) query += `&thirdPartiesID=${encodeURIComponent(filter.thirdPartiesID)}`;
        if (filter.cajaId) query += `&cajaId=${encodeURIComponent(filter.cajaId)}`;
        if (filter.dateFrom) query += `&dateFrom=${encodeURIComponent(filter.dateFrom)}`;
        if (filter.dateTo) query += `&dateTo=${encodeURIComponent(filter.dateTo)}`;

        let res;
        if (tipo === 'gastos') {
            res = await api.get(`/gastos${query}`);
        } else if (tipo === 'thirdParties') {
            res = await api.get(`/thirdParties${query}`);
        } else if (tipo === 'categorias') {
            res = await api.get(`/categorias${query}`);
        } else if (tipo === 'cajas') {
            res = await api.get(`/cajas${query}`);
        }
        return {
            items: res.data.items,
            totalPages: Math.ceil(res.data.totalItems/ limit),
        }
    }
    catch (err) {
        console.error("Error fetching data:", err);
        return {
        items: [],
        totalPages: 1,
        };  
    }
}

export async function getItemsById(tipo, id) {
    try {
        let res;
        if(tipo === 'gastos' || tipo === 'thirdParties'){
            res = await api.get(`/${tipo}/${id}`);
        } else {
            res = await api.get(`/${tipo}/${id}`);
        }
    return { data: res.data };
  } catch (err) {
    console.error("Error fetching data:", err);
    return { data: [] };
  }
}

export async function saveData(tipo, data) {
    try {
        let res;
        if (tipo === 'gastos') {
            const payload = JSON.parse(JSON.stringify(data))
            res = await api.post(`/gastos`, payload);
        } else if (tipo === 'thirdParties') {
            res = await api.post(`/thirdParties`, data);
        } else if (tipo === 'categorias') {
            res = await api.post(`/categorias`, data);
        } else if (tipo === 'cajas') {
            res = await api.post(`/cajas`, data);
        }
        return {
            response: res.data
        }
    }
    catch (err) {
        console.error("Error saving data:", err);
    }
}

export async function editData(tipo, data, id) {
    try{
        let res;
        if (tipo === 'gastos' || tipo === 'thirdParties'){
            res = await api.patch(`/${tipo}/${id}`,data);
        } else {
            res = await api.patch(`/${tipo}/${id}`,data);
        }
        return res;
    } catch (err) {
        console.error("Error saving data:", err);
    }
}